import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52b5f00a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column h-100 position-relative w-100"
}
const _hoisted_2 = { class: "line-box top justify-content-center d-flex align-items-start h-50" }
const _hoisted_3 = { class: "info-btn" }
const _hoisted_4 = {
  key: 0,
  class: "btn btn-secondary h-100 info-btn d-flex align-items-center"
}
const _hoisted_5 = { class: "justify-content-center d-flex align-items-start h-50 bottom-title" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  key: 1,
  class: "d-flex flex-column h-100 position-relative w-100"
}
const _hoisted_8 = { class: "line-box bottom justify-content-center d-flex align-items-end h-50" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "justify-content-center d-flex align-items-end h-50" }
const _hoisted_11 = { class: "info-btn" }
const _hoisted_12 = {
  key: 0,
  class: "btn btn-secondary h-100 info-btn d-flex align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TimelineEntryContent = _resolveComponent("TimelineEntryContent")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.index % 2 == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "responsive-height d-flex title-box",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.displayInfo && _ctx.displayInfo(...args)))
            }, [
              _createElementVNode("button", {
                class: _normalizeClass([_ctx.disableHover, "btn btn-primary h-100"])
              }, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.timePeriod), 1)
              ], 2),
              (_ctx.showOverlay)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'chevron-down'] })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("p", _hoisted_6, null, 512), [
              [_directive_dompurify_html, _ctx.entry.title]
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("p", _hoisted_9, null, 512), [
              [_directive_dompurify_html, _ctx.entry.title]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "responsive-height d-flex title-box",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.displayInfo && _ctx.displayInfo(...args)))
            }, [
              _createElementVNode("button", {
                class: _normalizeClass([_ctx.disableHover, "btn btn-primary h-100"])
              }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.timePeriod), 1)
              ], 2),
              (_ctx.showOverlay)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'chevron-down'] })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])),
    _createVNode(_component_OverlayPanel, {
      ref: "info",
      appendto: "body",
      class: "wdw-widgets timeline",
      showCloseIcon: true,
      dismissable: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TimelineEntryContent, {
          entry: _ctx.entry,
          fullScreenImage: _ctx.showInfo
        }, null, 8, ["entry", "fullScreenImage"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Dialog, {
      visible: _ctx.showInfo,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showInfo) = $event)),
      dismissableMask: true,
      appendto: "body",
      breakpoints: { '960px': '75vw', '640px': '100vw' },
      style: { width: '50vw' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TimelineEntryContent, {
          entry: _ctx.entry,
          fullScreenImage: _ctx.showInfo
        }, null, 8, ["entry", "fullScreenImage"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}